import { useState } from "react";
import Payment from "./payment";
import Thankyou from "./thankyou";

const Index = () => {
    const [orderPlaced, setOrderPlaced] = useState(false);
    return orderPlaced ? <Thankyou data={orderPlaced} /> : <Payment setOrderPlaced={setOrderPlaced} />;
};
export default Index;
